import { MatDialog } from '@angular/material';
import { ModalSaveImageComponent } from '../modal-save-image/modal-save-image.component';
import { SetScaleModalComponent } from '../services/proTools/ng-components/set-scale-modal/set-scale-modal.component';

import { Component, OnInit } from '@angular/core';
import { ToolSwitcher } from '../services/proTools/ToolSwitcher';
import { PrintService } from '../services/proTools/print.service';
import { StageService } from '../services/stage.service';
import { ProToolsUiManagerService } from '../services/pro-tools-ui-manager.service';
import { RailingGenerationService } from '../services/railing/services/railing-generation.service';
import { PlanBuilderService } from '../services/proTools/plan-builder.service';
import { DrawingsHolderService } from '../services/proTools/drawings-holder.service';
import { DrawTitleBlockComponent } from '../services/proTools/components/DrawTitleBlockComponent';
import { SelectComponent } from '../services/proTools/components';
import { ZoomService } from '../services/zoom.service';
import { CameraService } from '../services/camera.service';

@Component({
  selector: 'app-step3-list',
  templateUrl: './step3-list.component.html',
  styleUrls: ['./step3-list.component.scss']
})
export class Step3ListComponent implements OnInit {
  selectedIndex = -1;
  saved: boolean;

  constructor(
    public dialog: MatDialog,
    private toolSwitcher: ToolSwitcher,
    private printSrvc: PrintService,
    private stage: StageService,
    private proToolsUiSrvc: ProToolsUiManagerService,
    private railingGenerationService: RailingGenerationService,
    private planBuilderService: PlanBuilderService,
    private drawTitleBlock: DrawTitleBlockComponent,
    private selectComponent: SelectComponent,
    private drawings: DrawingsHolderService,
    private zoomService: ZoomService,
    private cameraManager: CameraService
  ) {
    this.drawings.saved.subscribe(value => {
      this.saved = value;
    });
    proToolsUiSrvc.proToolsModActive
    .subscribe(async isActive => {
      if (isActive && !this.saved) {
          const data = await this.railingGenerationService.buildRailing(true);
          this.planBuilderService.build(data);
        }
    });
    this.selectComponent.SelectModeOn.subscribe(async isActive => {
      if (isActive && this.selectedIndex !== 0) {
        this.select(0);
      }
    });
  }

  openViewImagesDialog(): void {
    this.dialog.open(ModalSaveImageComponent, {
      width: '60%'
    });
  }

  singleLine(selectedIndex) {
    this.toolSwitcher.singleLine();
    this.selectedIndex = selectedIndex;
  }

  move(selectedIndex) {
    this.toolSwitcher.moveObject();
    this.selectedIndex = selectedIndex;
  }

  select(selectedIndex) {
    this.toolSwitcher.select();
    this.selectedIndex = selectedIndex;
  }

  polyline(selectedIndex) {
    this.toolSwitcher.polyline();
    this.selectedIndex = selectedIndex;
  }

  arc(selectedIndex) {
    this.toolSwitcher.arc();
    this.selectedIndex = selectedIndex;
  }

  circle(selectedIndex) {
    this.toolSwitcher.circle();
    this.selectedIndex = selectedIndex;
  }

  rectangle(selectedIndex) {
    this.toolSwitcher.rectangle();
    this.selectedIndex = selectedIndex;
  }

  angle(selectedIndex) {
    this.toolSwitcher.angle();
    this.selectedIndex = selectedIndex;
  }

  dimensions(selectedIndex) {
    this.toolSwitcher.dimensions();
    this.selectedIndex = selectedIndex;
  }

  text(selectedIndex) {
    this.toolSwitcher.text();
    this.selectedIndex = selectedIndex;
  }

  setScale() {
    this.dialog.open(SetScaleModalComponent, {
      width: '300px'
    });
  }

  print() {
    this.printSrvc.print();
  }

  addPost(selectedIndex) {
    this.toolSwitcher.addPost();
    this.selectedIndex = selectedIndex;
  }

  addTitleBlock() {
    this.drawTitleBlock.addTitleBlock();
  }

  addPicket(selectedIndex) {
    this.toolSwitcher.addPicket();
    this.selectedIndex = selectedIndex;
  }

  addCornerPost(selectedIndex) {
    this.toolSwitcher.addCornerPost();
    this.selectedIndex = selectedIndex;
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/step3-list/step3-list.component.ts